import InformationIcon from '@atlaskit/icon/core/information';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import type { ReactElement } from 'react';

const boxStyles = xcss({
	display: 'inline',
	paddingLeft: 'space.100',
});

type CodeReviewerSettingProps = {
	content: string;
	label: string;
};
export const CodeReviewerSettingTooltip = ({
	content,
	label,
}: CodeReviewerSettingProps): ReactElement => {
	return (
		<Tooltip content={content} position="top">
			{(tooltipProps) => (
				<Box {...tooltipProps} xcss={boxStyles}>
					<InformationIcon label={label} />
				</Box>
			)}
		</Tooltip>
	);
};
